export const TranslationIdMap = '';

export const TranslationKeyMap = {
    '_785_PERFORMER': 'Performer',
    '_822_DRILL_PATH': 'Drill Path',
    '_7313_LAST_UPDATE': 'Last Update',
    '_9395_RESET_GRID': 'Reset Grid',
    '_10079_NO_WINNING___DATA_IS_AVAILABLE': 'No Winning % Data is available',
    '_10085_WINNING': 'Winning',
    '_10091_EXPAND_ROW': 'Expand Row',
    '_10092_COLLAPSE_ROW': 'Collapse Row',
    '_10093_THIS_USER_NO_LONGER_REPORTS_TO_THIS_MANAGER': 'This user no longer reports to this manager',
    '_10094_WINNING_PERCENTAGE': 'Winning %',
    '_11154_IMPROVING': 'Improving',
    '_11155_DECLINING': 'Declining',
    '_11206_VIEW_COMMITMENT_DETAILS': 'View Commitment Details',
    '_11264_ADDITIONAL_INFORMATION': 'Additional Information',
    '_11265_ASSESSED_COMMITS': 'Assessed Commits',
    '_11266_ASSESSMENT_PERIOD': 'Assessment Period',
    '_11267_EXCLUDED_COMMITS': 'Excluded Commits',
    '_11268_SELECTED_TIME_RANGE': 'Selected Time Range',
    '_11269_WINNING_PERCENTAGE_DISTRIBUTION': 'Winning % Distribution',
    '_11270_WINNING_PERCENTAGE_TIME_RANGE': 'Winning % Time Range',
    '_11271_LOAD_USER': 'Load user'
};
